'use client';

import { Button, Skeleton } from '@shared/components/shadcn';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import { LottoCarousel } from '../../lotteries/LottoCarousel/LottoCarousel';
import type { LotteryName } from '../../lottery-purchases/types';

type DiscoverPageLottoCarouselProps = Omit<ComponentProps<typeof LottoCarousel>, 'lotteries' | 'moreInfoButtons' | 'carouselProps' | 'title'>;

const lotteries: LotteryName[] = ['irishLotto', 'megaMillions', 'powerBall', 'euroDreams', 'euroMillionsPlus'],
  NAMESPACE = 'lotteries.discover_page.lotteries_carousel';

/**
 * Carousel of lotteries section for lotteries discover page.
 * Based on the list of lotteries provided renders LottoCarousel component with LotteryPod inside, action button and section title.
 * @returns LottoCarousel component.
 */
function DiscoverPageLottoCarousel(props: DiscoverPageLottoCarouselProps) {
  const t = useTranslations(NAMESPACE);

  const buttons = {
    skeleton: <Skeleton className={`w-40 rounded-full h-8`} />,
    btn: (
      <Button size="s" variant="secondary" asChild data-track-name="View All">
        <Link href={ROUTES.LOTTO.CATEGORIES.ALL}>{t('btn')}</Link>
      </Button>
    ),
  };

  return <LottoCarousel lotteries={lotteries} title={t('title')} moreInfoButtons={buttons} {...props} data-testid="featured-lotteries-carousel" />;
}

export { DiscoverPageLottoCarousel };
